import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
export const dayPriceOverrideSchema = z.object({
    date: isoDateOnlySchema,
    price_per_night_cents: z.number().int().min(0),
});
export const bulkDayPriceOverrideSchema = z.object({
    dates: z.array(isoDateOnlySchema).min(1),
    price_per_night_cents: z.number().int().min(0),
});
export const dayPriceOverridesQuerySchema = z.object({
    from: isoDateOnlySchema.optional(),
    to: isoDateOnlySchema.optional(),
});
